import { ReactNode, useEffect, useState } from "react";
import SortArrowDescIcon from "../../../assets/icons/sortdown.svg";
import SortArrowAscIcon from "../../../assets/icons/sortup.svg";
import RemoveIcon from "../../../assets/icons/remove.png";
import CloseIcon from "@mui/icons-material/Close";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, styled } from "@mui/material";
import { PlayerAvatar } from "../../../styled-components/PlayerCard.Styles";
import LabelText from "../../../ui/LabelText";
import React from "react";
import { IPlayerBuildUpPlay, IPlayerComparisonData, IPlayerFinalThird, PlayerDefence, SortableKeys } from "../../../types/IPlayerComparison";
import LabelNumber from "../../../styled-components/LabelNumber";
import SecondaryButton from "../../../ui/SecondaryButton";
import { useLoading } from "../../../contexts/LoadingContext";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import profile from "../../../assets/icons/Profile.png";
import search from "../../../assets/icons/Spyglass.png";
import { useNavigate } from "react-router-dom";
import { usePlayerSearch } from "../../../contexts/SearchPlayersContext";
import { BASE_URL } from "../../../config/apiUrls";
import { useAuth } from "../../../contexts/AuthContext";
import { useNotification } from "../../../contexts/NotificationContext";
import PWNotification from "../../PWNotification";
import { addUpdateSortListData } from "../../PlayerComparison/addOrUpdateSortList";
import CustomizedTooltips from "../../../ui/Tooltip";
import LoadingSpinner from "../../../ui/LoadingSpinner";
import noImageClub from "../../../assets/icons/noImageClub.svg";
import noImagePlayer from "../../../assets/icons/noImagePlayer.svg";
import noImageFlag from "../../../assets/icons/noImageFlag.svg";
import BookmarkBorderOutlinedIcon from "@mui/icons-material/BookmarkBorderOutlined";
import Switch from "../../../ui/CustomSwitch";
import { useNewPlayerShortlistContext } from "../../../contexts/NewPlayerShortlistContext";
import InfoIcon from "../../../assets/icons/infoicon.svg";
import GoldStar from "../../../assets/icons/GoldStar.png";
import PrimaryButton from "../../../ui/PrimaryButton";
import { ArchetypeInfoDrawer } from "../../../pages/Chemistry/UIContent";
import { formatNumberToKAndM } from "../../../utils/formatNumberToKandM";
import ExpandView from '../../../assets/icons/ExpandView.svg'
import DrawerComponent from "../../../ui/Drawer";
import FullViewSimulationPlayersTable from "./FullViewSimulationPlayersTable"

interface tableDataProps {
  tableData: IPlayerComparisonData[];
  sortKey: SortableKeys;
  setSortKey: React.Dispatch<React.SetStateAction<SortableKeys>>;
  isFormSortList?: boolean;
  benchmarkID?: number;
  isFromSimulation?: boolean;
  isFullView?: boolean;
}

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(even)": {
    backgroundColor: "#F2F5EE",
    border: "none",
  },
}));

const SimulationPlayersTable: React.FC<tableDataProps> = ({ tableData, sortKey, setSortKey, isFormSortList, benchmarkID , isFromSimulation , isFullView}) => {
  const { startLoading, stopLoading, loading } = useLoading();
  const navigate = useNavigate();
  const { reset, setOriginPage, addedPlayers, setAddedPlayers } = usePlayerSearch();
  const { userData } = useAuth();
  const {
    showNotification,
    hideNotification,
    displayNotification,
    setDisplayNotification,
    notificationContent,
    setNotificationContent,
    setShouldHideAfterTimeout,
  } = useNotification();

  // const [addedPlayers, setAddedPlayers] = useState<number[]>([]);
  let environment = process.env.REACT_APP_MODE ?? "";

  const [expandedSections, setExpandedSections] = useState({
    finalThird: false,
    buildUpPlay: false,
    defense: false,
  });
  const [filterSortData, setFilterSortData] = useState<IPlayerComparisonData[]>([]);
  const [isAscending, setIsAscending] = useState<boolean>(false);
  const [menuOpenPlayerId, setMenuOpenPlayerId] = useState<number | null>(null);
  const [selectedPlayerIds, setSelectedPlayerIds] = useState<number[]>([]);
  const [benchmarkRecord, setBenchmarkRecord] = useState<IPlayerComparisonData | null>(null);

  const [displayCustomNotification, setDisplayCustomNotification] = useState<boolean>(false);
  const [customNotificationContent, setCustomNotificationContent] = useState<ReactNode>(null);

  const [isRemovePlayer, setIsRemovePlayer] = useState<boolean>(false);
  const [undoPlayerIds, setISundoPlayerIds] = useState<number>();
  const [addedPlayerShortList, setAddedPlayerShortList] = useState<boolean>(false);

  const [scoreByComparison, setIsScoreByComparison] = useState<boolean>(false);
  const [isPlayerPosition, setIsPlayerPosition] = useState<boolean>(false);
  const [isPlayerLeague, setIsPlayerLeague] = useState<boolean>(false);

  const [toggleAddComparisonButton, setIsToggleAddComparisonButton] = useState<boolean>();
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const [activeArchetypeID, setActiveArchetypeID] = useState<number>(0);
  const [activeArchetypeName, setActiveArchetypeName] = useState<string>('');
  const [archetypeID, setArchetypeID] = useState<number>(0);
  const [isFullViewTable , setIsFullViewTable] = useState<boolean>(false)

  // Determine the selection state
  const allSelected = selectedPlayerIds.length === filterSortData.length;
  const noneSelected = selectedPlayerIds.length === 0;
  const someSelected = selectedPlayerIds.length > 0 && !allSelected;

  const getNestedValue = (obj: any, path: string) => {
    return path.split(".").reduce((acc, part) => {
      if (acc) {
        // Check if part includes array notation
        const match = part.match(/(\w+)\[(\d+)\]/);
        if (match) {
          const [, arrayProp, index] = match;
          return acc[arrayProp] && acc[arrayProp][index];
        }
        return acc[part];
      }
      return undefined;
    }, obj);
  };

  useEffect(() => {
    if (tableData.length === 0) return;

    let processedData = [...tableData];

    processedData.sort((a, b) => {
      const aValue = getNestedValue(a, "attackContribution");
      const bValue = getNestedValue(b, "attackContribution");
      return bValue - aValue;
    });

    if (benchmarkID) {
      const benchmark = processedData.find((player) => player.playerId === benchmarkID) || null;
      const filteredData = processedData.filter((player) => player.playerId !== benchmarkID);
      setBenchmarkRecord(benchmark);
      setFilterSortData(filteredData);
    } else {
      setFilterSortData(processedData);
      setBenchmarkRecord(null);
    }
  }, [tableData, benchmarkID]);

  const handleSortClick = (key: SortableKeys) => {
    startLoading();
    const ascending = sortKey === key ? !isAscending : true; // Toggle sort order if the same column is clicked
    setIsAscending(ascending);
    setSortKey(key);

    const sortedData = [...filterSortData].sort((a, b) => {
      const aValue = getNestedValue(a, key);
      const bValue = getNestedValue(b, key);
      if (aValue === undefined || bValue === undefined) {
        return 0;
      }

      if (typeof aValue === "string" && typeof bValue === "string") {
        return ascending ? aValue.localeCompare(bValue) : bValue.localeCompare(aValue);
      }

      return ascending ? aValue - bValue : bValue - aValue;
    });
    setFilterSortData(sortedData);
    setTimeout(() => {
      stopLoading();
    }, 200);
  };

  const toggleExpand = (section: keyof typeof expandedSections) => {
    setExpandedSections((prev) => ({
      ...prev,
      [section]: !prev[section],
    }));
  };

  const getBackgroundColor = (performanceValue?: number, universal?: boolean) => {
    if (performanceValue == null) {
      return "none";
    }
    if (!isPlayerLeague && !universal) {
      performanceValue = Math.ceil(performanceValue);
    }
    if (performanceValue > 0 && performanceValue <= 24.99) {
      return "var(--UI-red-500, #FF3864)";
    } else if (performanceValue >= 25 && performanceValue <= 49.99) {
      return "var(--Brand-orange-500, #FF7800)";
    } else if (performanceValue >= 50 && performanceValue <= 74.99) {
      return "var(--UI-yellow-500, #F2E94E)";
    } else if (performanceValue >= 75 && performanceValue <= 87.99) {
      return "#C9F0B6";
    } else if (performanceValue >= 88 && performanceValue <= 98.99) {
      return "var(--Brand-green-2-500, #4AF075)";
    } else if (performanceValue >= 99) {
      return "#00D1A8";
    } else if (performanceValue === 0) {
      return "#DADADA";
    } else {
      return "red";
    }
  };

  const getTextColor = (score: number) => {
    if (score > 49) {
      return "var(--UI-black-500, #000000)";
    } else {
      return "var(--UI-white-500, #FFFFFF)";
    }
  };

  // Handle checkbox change - toggle the playerId in the array
  const handleCheckboxChange = (playerId: number) => {
    setSelectedPlayerIds(
      (prevState) =>
        prevState.includes(playerId)
          ? prevState.filter((id) => id !== playerId) // Remove playerId if already selected
          : [...prevState, playerId] // Add playerId if not selected
    );
  };

  // Handle select all
  const handleSelectAll = () => {
    const allPlayerIds = filterSortData.map((player) => player.playerId);
    setSelectedPlayerIds((prevSelectedPlayerIds) => [
      ...prevSelectedPlayerIds,
      ...(benchmarkRecord?.playerId != null ? [benchmarkRecord.playerId] : []),
      ...allPlayerIds,
    ]);

    // setSelectedPlayerIds(allPlayerIds)
  };

  // Handle deselect all
  const handleDeselectAll = () => {
    setSelectedPlayerIds([]);
  };

  // Initialize the addedPlayers state when tableData changes
  useEffect(() => {
    if (tableData?.length) {
      const initialStatus = tableData.reduce((acc: any, player) => {
        acc[player.playerId] = player.isPlayerInShortlist || false; // Use existing value or default to false
        return acc;
      }, {});
      setAddedPlayers(initialStatus);
    }
  }, [tableData]);

  const { newlyAddedPlayerCount, setNewlyAddedPlayerCount } = useNewPlayerShortlistContext();

  //hanlde add multiple players
  //---------------------------
  const handleAddorUpdateSortList = async () => {
    setNewlyAddedPlayerCount((prev) => prev + 1);
    //object state for which players are added
    setAddedPlayers((prevAddedPlayers: any) => {
      const updatedPlayers = { ...prevAddedPlayers };
      selectedPlayerIds.forEach((playerId: number) => {
        updatedPlayers[playerId] = !prevAddedPlayers[playerId]; // Toggle the boolean value
      });
      return updatedPlayers;
    });
    setAddedPlayerShortList(true);
    await addUpdateSortListData(
      userData,
      selectedPlayerIds,
      startLoading,
      stopLoading,
      setDisplayCustomNotification,
      setCustomNotificationContent,
      false,
      navigate
    );
    setSelectedPlayerIds([]);
    setCustomNotificationContent(
      <div className="notification">
        <p className="sortlist-notofication-content">
          <BookmarkBorderOutlinedIcon className="icon" />
          <LabelText className="squad-chart-tooltip notification-content">Players added to your shortlist</LabelText>
          <LabelText
            className="player-given-name notification-content"
            style={{ cursor: "pointer" }}
            onClick={() => navigate("/shortlists")}
          >
            View shortlist
          </LabelText>
        </p>
      </div>
    );
  };

  // Handle Add/Remove Player with add added toggle undo funtionality for individual player
  //---------------------------------------------------------------------------------------
  const handleAddPlayer = (playerId: number) => {
    setNewlyAddedPlayerCount((prev) => prev + 1); //debashish
    setISundoPlayerIds(playerId);
    //object state for which players are added
    setAddedPlayers((prevAddedPlayers: any) => ({
      ...prevAddedPlayers,
      [playerId]: !prevAddedPlayers[playerId], // Toggle the boolean value
    }));

    const isCurrentlyInShortlist = addedPlayers[playerId];

    if (isCurrentlyInShortlist) {
      // Remove from shortlist
      setAddedPlayerShortList(false);
      addUpdateSortListData(
        userData,
        [playerId],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        true,
        navigate
      );
      setCustomNotificationContent(
        <div className="notification">
          <p className="sortlist-notofication-content">
            <BookmarkBorderOutlinedIcon className="icon" />
            <LabelText className="squad-chart-tooltip notification-content">Player removed from your shortlist </LabelText>
            <LabelText
              className="player-given-name notification-content"
              style={{ cursor: "pointer" }}
              onClick={() => handleActions(playerId)}
            >
              Undo
            </LabelText>
          </p>
        </div>
      );
    } else {
      // Add to shortlist
      setAddedPlayerShortList(true);
      addUpdateSortListData(
        userData,
        [playerId],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        false,
        navigate
      );
      setCustomNotificationContent(
        <div className="notification">
          {/* <InfoOutlinedIcon className='icon' /> */}
          <p className="sortlist-notofication-content">
            <BookmarkBorderOutlinedIcon className="icon" />
            <LabelText className="squad-chart-tooltip notification-content">Player added to your shortlist</LabelText>
            <LabelText
              className="player-given-name notification-content"
              style={{ cursor: "pointer" }}
              onClick={() => navigate("/shortlists")}
            >
              View shortlist
            </LabelText>
          </p>
        </div>
      );
    }
  };

  // handle remove for indivudal player
  //-------------------------------------
  const handleSingleRemove = (playerId: number) => {
    // Add playerId to local storage
    //localStorage.setItem('removedPlayerIds', JSON.stringify([playerId]));
    setIsRemovePlayer(true);
    // setISundoPlayerIds([playerId])
    let storedRemovePlayerIds: number[] = JSON.parse(localStorage.getItem("removedIds") || "[]");
    if (storedRemovePlayerIds && storedRemovePlayerIds.length > 0) {
      if (!storedRemovePlayerIds.includes(playerId)) {
        storedRemovePlayerIds.push(playerId); // Add only if it's not a duplicate
      }
      localStorage.setItem("removedIds", JSON.stringify(storedRemovePlayerIds));
    } else {
      localStorage.setItem("removedIds", JSON.stringify([playerId]));
    }

    addUpdateSortListData(
      userData,
      [playerId],
      startLoading,
      stopLoading,
      setDisplayCustomNotification,
      setCustomNotificationContent,
      true,
      navigate
    );
    setFilterSortData((prevData) => prevData.filter((player) => player.playerId !== playerId));
    setCustomNotificationContent(
      <div className="notification">
        <p className="sortlist-notofication-content">
          <BookmarkBorderOutlinedIcon className="icon" />
          <LabelText className="squad-chart-tooltip notification-content">Player removed from your shortlist </LabelText>
          <LabelText
            className="player-given-name notification-content"
            style={{ cursor: "pointer" }}
            onClick={() => handleActions(playerId)}
          >
            Undo
          </LabelText>
        </p>
      </div>
    );
  };

  //handle multiple remove players
  //------------------------------------
  const handleRemovePlayer = () => {
    // Add selectedPlayerIds to local storage
    //localStorage.setItem('removedPlayerIds', JSON.stringify(selectedPlayerIds));
    setIsRemovePlayer(true);
    // setISundoPlayerIds(selectedPlayerIds)
    let storedRemovePlayerIds: number[] = JSON.parse(localStorage.getItem("removedIds") || "[]");
    if (storedRemovePlayerIds && storedRemovePlayerIds.length > 0) {
      //const combinedArray: number[] = storedRemovePlayerIds.concat(selectedPlayerIds).filter((value, index, self) => self.indexOf(value) === index);
      //setSelectedPlayerIds(selectedPlayerIds.filter((num:number) => !storedRemovePlayerIds.includes(num))); // Remove duplicates
      const combinedArray: number[] = storedRemovePlayerIds
        .concat(selectedPlayerIds)
        .filter((value, index, self) => self.indexOf(value) === index);
      setSelectedPlayerIds(combinedArray);
      storedRemovePlayerIds = storedRemovePlayerIds.concat(selectedPlayerIds); // Add the unique numbers
      localStorage.setItem("removedIds", JSON.stringify(storedRemovePlayerIds));
    } else {
      localStorage.setItem("removedIds", JSON.stringify(selectedPlayerIds));
    }

    addUpdateSortListData(
      userData,
      selectedPlayerIds,
      startLoading,
      stopLoading,
      setDisplayCustomNotification,
      setCustomNotificationContent,
      true,
      navigate
    );
    setFilterSortData((prevData) => prevData.filter((player) => !selectedPlayerIds.includes(player.playerId)));
    setCustomNotificationContent(
      <div className="notification">
        <p className="sortlist-notofication-content">
          <BookmarkBorderOutlinedIcon className="icon" />
          <LabelText className="squad-chart-tooltip notification-content">Players removed from your shortlist </LabelText>
          <LabelText className="player-given-name notification-content" style={{ cursor: "pointer" }} onClick={() => handleActions()}>
            Undo
          </LabelText>
        </p>
      </div>
    );
    setSelectedPlayerIds([]);
  };

  //handle the undo functionality for remove players
  //-----------------------------------------------

  const handleActions = (playerId?: number) => {
    if (selectedPlayerIds.length > 0 && isFormSortList) {
      addUpdateSortListData(
        userData,
        selectedPlayerIds!,
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        false,
        navigate
      );
      setFilterSortData((prevData: any) => {
        // Find all players that are in selectedPlayerIds but not in prevData
        const playersToAdd = selectedPlayerIds
          .filter((playerId) => !prevData.some((player: any) => player.playerId === playerId))
          .map((playerId) => tableData.find((player) => player.playerId === playerId))
          .filter((player) => player); // Filter out any undefined results

        // Merge the new players with the previous data
        return [...prevData, ...playersToAdd];
      });
    } else {
      setAddedPlayers((prevAddedPlayers: any) => {
        const isCurrentlyInShortlist = prevAddedPlayers[playerId!];
        const updatedAddedPlayers = {
          ...prevAddedPlayers,
          [playerId!]: !isCurrentlyInShortlist, // Toggle the shortlist status
        };
        return updatedAddedPlayers;
      });

      addUpdateSortListData(
        userData,
        [playerId!],
        startLoading,
        stopLoading,
        setDisplayCustomNotification,
        setCustomNotificationContent,
        false,
        navigate
      );

      if (isFormSortList) {
        setFilterSortData((prevData) => {
          // Check if the player is already in prevData
          const playerExists = prevData.some((player) => player.playerId === playerId);

          // If the player doesn't exist, add it; otherwise, leave prevData unchanged
          if (!playerExists) {
            const playerToAdd = tableData.find((player) => player.playerId === playerId);
            return playerToAdd ? [...prevData, playerToAdd] : prevData;
          }

          return prevData;
        });
      }
    }

    // setFilterSortData(tableData);
    // setSelectedPlayerIds([])
    // setSortKey('')
  };

  const handleMenuOpen = (playerId: number) => {
    setMenuOpenPlayerId((prevId) => (prevId === playerId ? null : playerId));
  };

  const handleSimilarSearch = (playerId: number) => {
    reset();
    window.open(`${BASE_URL}/player/${playerId}?tab=SimilarPlayers`, "_blank");
    setOriginPage("Similarplayers Tab");
  };

  const renderMenuCard = (playerId: number) => {
    return (
      <>
        <div className="menu-card-container">
          <div className="menu-list-container">
            <LabelNumber className="attack-defense-data">OPTIONS</LabelNumber>
          </div>
          {isFormSortList && (
            <div className="menu-list-container" onClick={() => handleSingleRemove(playerId)}>
              <img src={RemoveIcon} height={24} width={24} /> <LabelText className="remove-sortlist-text">Remove from shortlist</LabelText>
            </div>
          )}

          <div
            className="menu-list-container"
            onClick={() => {
              navigate(`/player/${playerId}`);
            }}
          >
            <img src={profile} height={24} width={24} />
            <LabelText className="menu-list">Player Profile</LabelText>
          </div>
          <div
            className="menu-list-container"
            onClick={() => {
              handleSimilarSearch(playerId);
            }}
          >
            <img src={search} height={24} width={24} />
            <LabelText className="menu-list">Search for similar</LabelText>
          </div>
          {/* {!isFormSortList && (
                        <div
                        className={`menu-list-container ${
                          addedPlayers.includes(playerId) ? 'added' : ''
                        }`}
                      >
                            <BookmarkBorderIcon /><LabelText className='menu-list' style={{ color: addedPlayers.includes(playerId) ? 'white' : '' }} onClick={() => handleAddPlayer(playerId)}>Add to shortlist</LabelText>
                        </div>
                    )} */}
          {/* {!isFormSortList && (
                        <div
                        className='menu-list-container'
                      >
                            <BookmarkBorderIcon /><LabelText className='menu-list' onClick={() => handleAddPlayer(playerId)}>Add to shortlist</LabelText>
                        </div>
                    )} */}
          {!isFormSortList && (
            <div className={`menu-list-container ${addedPlayers[playerId] ? "added" : ""}`} onClick={() => handleAddPlayer(playerId)}>
              <BookmarkBorderIcon />
              <LabelText className="menu-list" style={{ color: addedPlayers[playerId] ? "white" : "" }}>
                {addedPlayers[playerId] ? "Added to shortlist" : "Add to shortlist"}
              </LabelText>
            </div>
          )}
        </div>
      </>
    );
  };

  const handlePositionToggle = () => {
    startLoading();
    setIsPlayerPosition((prevState) => !prevState);
  };

  const handleLeagueToggle = () => {
    startLoading();
    setIsPlayerLeague((prevState) => !prevState);
  };

  const getDisplayedData = (player: {
    playerFinalThirdUniverse: IPlayerFinalThird;
    playerFinalThirdLeague: IPlayerFinalThird;
    playerBuildUpPlayUniverse: IPlayerBuildUpPlay;
    playerBuildUpPlayLeague: IPlayerBuildUpPlay;
    playerDefenceUniverse: PlayerDefence;
    playerDefenceLeague: PlayerDefence;
  }) => {
    let displayedData = {
      finalThird: {} as IPlayerFinalThird,
      buildUpPlay: {} as IPlayerBuildUpPlay,
      defence: {} as PlayerDefence,
    };

    // Final Third Data
    if (isPlayerLeague && isPlayerPosition) {
      displayedData.finalThird = {
        ...player.playerFinalThirdLeague,
        finalScore: player.playerFinalThirdLeague.finalScoreByPosition,
        finishingShots: player.playerFinalThirdLeague.finishingShotsByPosition,
        finishingAerial: player.playerFinalThirdLeague.finishingAerialByPosition,
        attackPositioning: player.playerFinalThirdLeague.attackPositioningByPosition,
      };
    } else if (isPlayerLeague) {
      displayedData.finalThird = player.playerFinalThirdLeague;
    } else if (isPlayerPosition) {
      displayedData.finalThird = {
        ...player.playerFinalThirdUniverse,
        finalScore: player.playerFinalThirdUniverse.finalScoreByPosition,
        finishingShots: player.playerFinalThirdUniverse.finishingShotsByPosition,
        finishingAerial: player.playerFinalThirdUniverse.finishingAerialByPosition,
        attackPositioning: player.playerFinalThirdUniverse.attackPositioningByPosition,
      };
    } else {
      displayedData.finalThird = player.playerFinalThirdUniverse;
    }

    // Build-Up Play Data
    if (isPlayerLeague && isPlayerPosition) {
      displayedData.buildUpPlay = {
        ...player.playerBuildUpPlayLeague,
        finalScore: player.playerBuildUpPlayLeague.finalScoreByPosition,
        creativity: player.playerBuildUpPlayLeague.creativityByPosition,
        passingAccuracy: player.playerBuildUpPlayLeague.passingAccuracyByPosition,
        dribbling: player.playerBuildUpPlayLeague.dribblingByPosition,
        crossing: player.playerBuildUpPlayLeague.crossingByPosition,
      };
    } else if (isPlayerLeague) {
      displayedData.buildUpPlay = player.playerBuildUpPlayLeague;
    } else if (isPlayerPosition) {
      displayedData.buildUpPlay = {
        ...player.playerBuildUpPlayUniverse,
        finalScore: player.playerBuildUpPlayUniverse.finalScoreByPosition,
        creativity: player.playerBuildUpPlayUniverse.creativityByPosition,
        passingAccuracy: player.playerBuildUpPlayUniverse.passingAccuracyByPosition,
        dribbling: player.playerBuildUpPlayUniverse.dribblingByPosition,
        crossing: player.playerBuildUpPlayUniverse.crossingByPosition,
      };
    } else {
      displayedData.buildUpPlay = player.playerBuildUpPlayUniverse;
    }

    // Defence Data
    if (isPlayerLeague && isPlayerPosition) {
      displayedData.defence = {
        ...player.playerDefenceLeague,
        finalScore: player.playerDefenceLeague.finalScoreByPosition,
        tackling: player.playerDefenceLeague.tacklingByPosition,
        defensiveHeaders: player.playerDefenceLeague.defensiveHeadersByPosition,
        aggression: player.playerDefenceLeague.aggressionByPosition,
      };
    } else if (isPlayerLeague) {
      displayedData.defence = player.playerDefenceLeague;
    } else if (isPlayerPosition) {
      displayedData.defence = {
        ...player.playerDefenceUniverse,
        finalScore: player.playerDefenceUniverse.finalScoreByPosition,
        tackling: player.playerDefenceUniverse.tacklingByPosition,
        defensiveHeaders: player.playerDefenceUniverse.defensiveHeadersByPosition,
        aggression: player.playerDefenceUniverse.aggressionByPosition,
      };
    } else {
      displayedData.defence = player.playerDefenceUniverse;
    }

    setTimeout(() => {
      stopLoading();
    }, 500);
    return displayedData;
  };

  const exportToCsv = () => {
    const headers = [
      'Player',
      'Age',
      'ArcheType',
      'Club',
      'Nationality',
      'Height(cm)',
      'Attack Contribution',
      'Final Third',
      'Finishing - Shots',
      'Finishing - Aerial',
      'Attack Positioning',
      'Build-Up Play',
      'Creativity',
      'Passing Accuracy',
      'Dribbling',
      'Crossing',
      'Defence',
      'Tackling',
      'Defensive Headers',
      'Ball Recovery',
      'Starts / As Sub',
      'Mins Played',
      'Market Value',
      'True Value',
      'Wages PW',
      'Contract Left'
    ];
  
   const rows =  filterSortData.map((player) => {
      const displayedData = getDisplayedData(player);
      return [
          player.playerLabel || '--',
          player?.age || '--',
          player?.archetype?.archetypeName! || '--',
          player?.clubName || '--',
          player?.nationality[0]?.name || '--',
          player?.heightInCM ? `${player?.heightInCM}` : '--',
          player?.attackContribution === 100 ? '99.99' : player?.attackContribution  || '--',
          displayedData?.finalThird?.finalScore === 100 ? '99.99' : displayedData?.finalThird?.finalScore?.toFixed(2)  || '--',
          displayedData?.finalThird?.finishingShots === 100 ? '99.99' : displayedData?.finalThird?.finishingShots?.toFixed(2) || '--',
          displayedData?.finalThird?.finishingAerial === 100 ? '99.99' : displayedData?.finalThird?.finishingAerial?.toFixed(2) || '--',
          displayedData?.finalThird?.attackPositioning === 100 ? '99.99' : displayedData?.finalThird?.attackPositioning?.toFixed(2) || '--',
          displayedData?.buildUpPlay?.finalScore === 100 ? '99.99' : displayedData?.buildUpPlay?.finalScore?.toFixed(2) || '--',
          displayedData?.buildUpPlay?.creativity === 100 ? '99.99' : displayedData?.buildUpPlay?.creativity?.toFixed(2) || '--',
          displayedData?.buildUpPlay?.passingAccuracy === 100 ? '99.99' : displayedData?.buildUpPlay?.passingAccuracy?.toFixed(2) || '--',
          displayedData?.buildUpPlay?.dribbling === 100 ? '99.99' : displayedData?.buildUpPlay?.dribbling?.toFixed(2) || '--',
          displayedData?.buildUpPlay?.crossing === 100 ? '99.99' : displayedData?.buildUpPlay?.crossing?.toFixed(2) || '--',
          displayedData?.defence?.finalScore === 100 ? '99.99' : displayedData?.defence?.finalScore?.toFixed(2) || '--',
          displayedData?.defence?.tackling === 100 ? '99.99' : displayedData?.defence?.tackling?.toFixed(2) || '--',
          displayedData?.defence?.defensiveHeaders === 100 ? '99.99' : displayedData?.defence?.defensiveHeaders?.toFixed(2) || '--',
          displayedData?.defence?.aggression === 100 ? '99.99' : displayedData?.defence?.aggression?.toFixed(2) || '--',
          player?.starts || '--',

          player?.minutesPlayed || '--',
          player?.marketValueText !== '0' ? `€${player?.marketValueText}` : '--',
          player?.trueValue ? `€${formatNumberToKAndM(player?.trueValue)}` : '--',
          player?.wagesText !== '0' ? `€${player?.wagesText}` : '--',
          player?.contract?.text || '--',
      ];
  });
  
    // Add BOM for proper UTF-8 encoding (includes € symbol)
    const csvContent = '\uFEFF' + [
      headers.join(','),
      ...rows.map(row => row.map(value => `"${value}"`).join(','))
    ].join('\n');
  
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const url = URL.createObjectURL(blob);
  
    const link = document.createElement('a');
    link.setAttribute('href', url);
    link.setAttribute('download', 'Player_shortlist.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const hanldeInfoClick = (archId: number,archName : string) => {
      setSidebarOpen(true)
      setArchetypeID(archId);
      setActiveArchetypeName(archName)

  };


  return (
    <>
      {loading && <LoadingSpinner />}
      <div
        // className='table-scroll min-height-table'
        className={isFullViewTable || isFullView
          ? filterSortData.length > 3
            ? "table-scroll"
            : "table-scroll min-height-table"
          : "fix-width-table"}
      >
        <TableContainer component={Paper} className="custom-table-test" sx={{width:'fit-content'}}>
          <Table className="custom-table">
            <TableHead className="custom-table-sticky" style={{zIndex: 10}}>
            {/* {!isFullView &&(<><TableRow style={{display:'flex'}}><SecondaryButton iconType="expandedview" onClick={()=>setIsFullViewTable(!isFullViewTable)}/></TableRow></>)} */}
              <TableRow>
                <TableCell style={{padding:'16px 12px 16px 0px'}}>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("playerLabel")}>
                      Player
                    </LabelText>
                    {sortKey === "playerLabel" && (
                      <img
                        src={sortKey === "playerLabel" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("playerLabel")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                {/* <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("topPosition")}>
                      Position
                    </LabelText>
                    {sortKey === "topPosition" && (
                      <img
                        src={sortKey === "topPosition" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("topPosition")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell> */}
                <TableCell style={{padding:'16px 12px 16px 0px'}}>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("wages")}>
                      Wages PW
                    </LabelText>
                    {sortKey === "wages" && (
                      <img
                        src={sortKey === "wages" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("wages")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell style={{padding:'16px 12px 16px 0px'}}>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("trueValue")}>
                      True Value
                    </LabelText>
                    {sortKey === "trueValue" && (
                      <img
                        src={sortKey === "trueValue" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("trueValue")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell style={{padding:'16px 12px 16px 0px'}} className={`sub-header sub-header-head ${expandedSections.finalThird ? "expand" : ""}`}>
                  <div className="attribute-score-header">
                    <div className="custon-align">
                      <LabelText
                        className="comparison-table-header"
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.finalScoreZscore"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                              : "playerFinalThirdUniverse.finalScoreZscore"
                          )
                        }
                      >
                        Final Third
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.finalScoreZscore"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                          : "playerFinalThirdUniverse.finalScoreZscore") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                                : "playerFinalThirdUniverse.finalScoreZscore") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerFinalThirdLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                                : "playerFinalThirdUniverse.finalScoreZscore"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    {isFullView && (<SecondaryButton
                      iconType={expandedSections.finalThird ? "keyboardarrowleft" : "keyboardarrowright"}
                      onClick={() => toggleExpand("finalThird")}
                      className="column-expand-btn"
                    />)}
                  </div>

                  <div className="test">
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.finishingShotsZScores"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                              : "playerFinalThirdUniverse.finishingShotsZScores"
                          )
                        }
                      >
                        Finishing - Shots
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.finishingShotsZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                          : "playerFinalThirdUniverse.finishingShotsZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.finishingShotsZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                                : "playerFinalThirdUniverse.finishingShotsZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                          ? "playerFinalThirdLeague.finishingShotsZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                          : "playerFinalThirdUniverse.finishingShotsZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.finishingAerialZScores"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                              : "playerFinalThirdUniverse.finishingAerialZScores"
                          )
                        }
                      >
                        Finishing - Aerial
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.finishingAerialZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                          : "playerFinalThirdUniverse.finishingAerialZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.finishingAerialZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                                : "playerFinalThirdUniverse.finishingAerialZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerFinalThirdLeague.finishingAerialZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                                : "playerFinalThirdUniverse.finishingAerialZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.attackPositioningZScores"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                              : "playerFinalThirdUniverse.attackPositioningZScores"
                          )
                        }
                      >
                        Atk. Positioning
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.attackPositioningZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                          : "playerFinalThirdUniverse.attackPositioningZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.attackPositioningZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                                : "playerFinalThirdUniverse.attackPositioningZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerFinalThirdLeague.attackPositioningZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                                : "playerFinalThirdUniverse.attackPositioningZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                  </div>
                </TableCell>

                <TableCell style={{padding:'16px 12px 16px 0px'}} className={`sub-header sub-header-head ${expandedSections.buildUpPlay ? "expand expand-big" : ""}`}>
                  <div className="attribute-score-header">
                    <div className="custon-align">
                      <LabelText
                        className="comparison-table-header"
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.finalScoreZscore"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                              : "playerBuildUpPlayUniverse.finalScoreZscore"
                          )
                        }
                      >
                        Build Up Play
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.finalScoreZscore"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                          : "playerBuildUpPlayUniverse.finalScoreZscore") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                                : "playerBuildUpPlayUniverse.finalScoreZscore") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                                : "playerBuildUpPlayUniverse.finalScoreZscore"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    {isFullView &&(
                      <SecondaryButton
                      iconType={expandedSections.buildUpPlay ? "keyboardarrowleft" : "keyboardarrowright"}
                      onClick={() => toggleExpand("buildUpPlay")}
                      className="column-expand-btn"
                    />
                    )}
                    
                  </div>
                  <div className="test">
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.creativityZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                              : "playerBuildUpPlayUniverse.creativityZScores"
                          )
                        }
                      >
                        Creativity
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.creativityZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                          : "playerBuildUpPlayUniverse.creativityZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.creativityZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                                : "playerBuildUpPlayUniverse.creativityZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.creativityZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                                : "playerBuildUpPlayUniverse.creativityZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>

                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                              : "playerBuildUpPlayUniverse.passingAccuracyZScores"
                          )
                        }
                      >
                        Passing accuracy
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                          : "playerBuildUpPlayUniverse.passingAccuracyZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                                : "playerBuildUpPlayUniverse.passingAccuracyZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                                : "playerBuildUpPlayUniverse.passingAccuracyZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.dribblingZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                              : "playerBuildUpPlayUniverse.dribblingZScores"
                          )
                        }
                      >
                        Dribbling
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.dribblingZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                          : "playerBuildUpPlayUniverse.dribblingZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.dribblingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                                : "playerBuildUpPlayUniverse.dribblingZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.dribblingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                                : "playerBuildUpPlayUniverse.dribblingZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.crossingZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                              : "playerBuildUpPlayUniverse.crossingZScores"
                          )
                        }
                      >
                        Crossing
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.crossingZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                          : "playerBuildUpPlayUniverse.crossingZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.crossingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                                : "playerBuildUpPlayUniverse.crossingZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.crossingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                                : "playerBuildUpPlayUniverse.crossingZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell style={{padding:'16px 12px 16px 0px'}} className={`sub-header sub-header-head ${expandedSections.defense ? "expand" : ""}`}>
                  <div className="attribute-score-header">
                    <div className="custon-align">
                      <LabelText
                        className="comparison-table-header"
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.finalScoreZscore"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.finalScoreByPositionZscore"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.finalScoreByPositionZscore"
                              : "playerDefenceUniverse.finalScoreZscore"
                          )
                        }
                      >
                        Defense
                      </LabelText>
                      <span>&nbsp;</span>
                      <span>&nbsp;</span>
                      <span>&nbsp;</span>
                      <span>&nbsp;</span>
                      {!isFullView&&(<SecondaryButton iconType="expandedview" onClick={()=>setIsFullViewTable(!isFullViewTable)}/>)}
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.finalScoreZscore"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.finalScoreByPositionZscore"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.finalScoreByPositionZscore"
                          : "playerDefenceUniverse.finalScoreZscore") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.finalScoreByPositionZscore"
                                : "playerDefenceUniverse.finalScoreZscore") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.finalScoreByPositionZscore"
                                : "playerDefenceUniverse.finalScoreZscore"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    {isFullView &&(<SecondaryButton
                      iconType={expandedSections.defense ? "keyboardarrowleft" : "keyboardarrowright"}
                      onClick={() => toggleExpand("defense")}
                      className="column-expand-btn"
                    />)}
                  </div>

                  <div className="test">
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.tacklingZScores"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.tacklingByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.tacklingByPositionZScores"
                              : "playerDefenceUniverse.tacklingZScores"
                          )
                        }
                      >
                        Tackling
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.tacklingZScores"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.tacklingByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.tacklingByPositionZScores"
                          : "playerDefenceUniverse.tacklingZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.tacklingZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.tacklingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.tacklingByPositionZScores"
                                : "playerDefenceUniverse.tacklingZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.tacklingZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.tacklingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.tacklingByPositionZScores"
                                : "playerDefenceUniverse.tacklingZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.defensiveHeadersZScores"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.defensiveHeadersByPosition"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.defensiveHeadersByPosition"
                              : "playerDefenceUniverse.defensiveHeadersZScores"
                          )
                        }
                      >
                        Def. headers
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.defensiveHeadersZScores"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.defensiveHeadersByPosition"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.defensiveHeadersByPosition"
                          : "playerDefenceUniverse.defensiveHeadersZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.defensiveHeadersZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.defensiveHeadersByPosition"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.defensiveHeadersByPosition"
                                : "playerDefenceUniverse.defensiveHeadersZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.defensiveHeadersZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.defensiveHeadersByPosition"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.defensiveHeadersByPosition"
                                : "playerDefenceUniverse.defensiveHeadersZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.aggressionZScores"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.aggressionByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.aggressionByPositionZScores"
                              : "playerDefenceUniverse.aggressionZScores"
                          )
                        }
                      >
                        Ball Recovery
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.aggressionZScores"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.aggressionByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.aggressionByPositionZScores"
                          : "playerDefenceUniverse.aggressionZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.aggressionZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.aggressionByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.aggressionByPositionZScores"
                                : "playerDefenceUniverse.aggressionZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.aggressionZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.aggressionByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.aggressionByPositionZScores"
                                : "playerDefenceUniverse.aggressionZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                  </div>
                </TableCell>
                
               
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("archetype.archetypeName")}>
                      Archetype
                    </LabelText>
                    {sortKey === "archetype.archetypeName" && (
                      <img
                        src={sortKey === "archetype.archetypeName" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("archetype.archetypeName")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("clubName")}>
                      Club
                    </LabelText>
                    {sortKey === "clubName" && (
                      <img
                        src={sortKey === "clubName" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("clubName")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("nationality[0].name")}>
                      Nat.
                    </LabelText>
                    {sortKey === "nationality[0].name" && (
                      <img
                        src={sortKey === "nationality[0].name" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("nationality[0].name")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("heightInCM")}>
                      Height
                    </LabelText>
                    {sortKey === "heightInCM" && (
                      <img
                        src={sortKey === "heightInCM" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("heightInCM")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("attackContribution")}>
                      Attack Contribution
                    </LabelText>
                    {sortKey === "attackContribution" && (
                      <img
                        src={sortKey === "attackContribution" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("attackContribution")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell className={`sub-header sub-header-head ${expandedSections.finalThird ? "expand" : ""}`}>
                  <div className="attribute-score-header">
                    <div className="custon-align">
                      <LabelText
                        className="comparison-table-header"
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.finalScoreZscore"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                              : "playerFinalThirdUniverse.finalScoreZscore"
                          )
                        }
                      >
                        Final Third
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.finalScoreZscore"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                          : "playerFinalThirdUniverse.finalScoreZscore") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                                : "playerFinalThirdUniverse.finalScoreZscore") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerFinalThirdLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finalScoreByPositionZscore"
                                : "playerFinalThirdUniverse.finalScoreZscore"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <SecondaryButton
                      iconType={expandedSections.finalThird ? "keyboardarrowleft" : "keyboardarrowright"}
                      onClick={() => toggleExpand("finalThird")}
                      className="column-expand-btn"
                    />
                  </div>

                  <div className="test">
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.finishingShotsZScores"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                              : "playerFinalThirdUniverse.finishingShotsZScores"
                          )
                        }
                      >
                        Finishing - Shots
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.finishingShotsZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                          : "playerFinalThirdUniverse.finishingShotsZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.finishingShotsZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                                : "playerFinalThirdUniverse.finishingShotsZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                          ? "playerFinalThirdLeague.finishingShotsZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finishingShotsByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finishingShotsByPositionZScores"
                          : "playerFinalThirdUniverse.finishingShotsZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.finishingAerialZScores"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                              : "playerFinalThirdUniverse.finishingAerialZScores"
                          )
                        }
                      >
                        Finishing - Aerial
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.finishingAerialZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                          : "playerFinalThirdUniverse.finishingAerialZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.finishingAerialZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                                : "playerFinalThirdUniverse.finishingAerialZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerFinalThirdLeague.finishingAerialZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.finishingAerialByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.finishingAerialByPositionZScores"
                                : "playerFinalThirdUniverse.finishingAerialZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerFinalThirdLeague.attackPositioningZScores"
                              : isPlayerPosition
                              ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                              : "playerFinalThirdUniverse.attackPositioningZScores"
                          )
                        }
                      >
                        Atk. Positioning
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerFinalThirdLeague.attackPositioningZScores"
                          : isPlayerPosition
                          ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                          : "playerFinalThirdUniverse.attackPositioningZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerFinalThirdLeague.attackPositioningZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                                : "playerFinalThirdUniverse.attackPositioningZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerFinalThirdLeague.attackPositioningZScores"
                                : isPlayerPosition
                                ? "playerFinalThirdUniverse.attackPositioningByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerFinalThirdLeague.attackPositioningByPositionZScores"
                                : "playerFinalThirdUniverse.attackPositioningZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                  </div>
                </TableCell>

                <TableCell className={`sub-header sub-header-head ${expandedSections.buildUpPlay ? "expand expand-big" : ""}`}>
                  <div className="attribute-score-header">
                    <div className="custon-align">
                      <LabelText
                        className="comparison-table-header"
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.finalScoreZscore"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                              : "playerBuildUpPlayUniverse.finalScoreZscore"
                          )
                        }
                      >
                        Build Up Play
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.finalScoreZscore"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                          : "playerBuildUpPlayUniverse.finalScoreZscore") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                                : "playerBuildUpPlayUniverse.finalScoreZscore") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.finalScoreByPositionZscore"
                                : "playerBuildUpPlayUniverse.finalScoreZscore"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <SecondaryButton
                      iconType={expandedSections.buildUpPlay ? "keyboardarrowleft" : "keyboardarrowright"}
                      onClick={() => toggleExpand("buildUpPlay")}
                      className="column-expand-btn"
                    />
                  </div>
                  <div className="test">
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.creativityZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                              : "playerBuildUpPlayUniverse.creativityZScores"
                          )
                        }
                      >
                        Creativity
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.creativityZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                          : "playerBuildUpPlayUniverse.creativityZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.creativityZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                                : "playerBuildUpPlayUniverse.creativityZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.creativityZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.creativityByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.creativityByPositionZScores"
                                : "playerBuildUpPlayUniverse.creativityZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>

                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                              : "playerBuildUpPlayUniverse.passingAccuracyZScores"
                          )
                        }
                      >
                        Passing accuracy
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                          : "playerBuildUpPlayUniverse.passingAccuracyZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                                : "playerBuildUpPlayUniverse.passingAccuracyZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.passingAccuracyZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.passingAccuracyByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.passingAccuracyByPositionZScores"
                                : "playerBuildUpPlayUniverse.passingAccuracyZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.dribblingZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                              : "playerBuildUpPlayUniverse.dribblingZScores"
                          )
                        }
                      >
                        Dribbling
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.dribblingZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                          : "playerBuildUpPlayUniverse.dribblingZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.dribblingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                                : "playerBuildUpPlayUniverse.dribblingZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.dribblingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.dribblingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.dribblingByPositionZScores"
                                : "playerBuildUpPlayUniverse.dribblingZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerBuildUpPlayLeague.crossingZScores"
                              : isPlayerPosition
                              ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                              : "playerBuildUpPlayUniverse.crossingZScores"
                          )
                        }
                      >
                        Crossing
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerBuildUpPlayLeague.crossingZScores"
                          : isPlayerPosition
                          ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                          : "playerBuildUpPlayUniverse.crossingZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerBuildUpPlayLeague.crossingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                                : "playerBuildUpPlayUniverse.crossingZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerBuildUpPlayLeague.crossingZScores"
                                : isPlayerPosition
                                ? "playerBuildUpPlayUniverse.crossingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerBuildUpPlayLeague.crossingByPositionZScores"
                                : "playerBuildUpPlayUniverse.crossingZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell className={`sub-header sub-header-head ${expandedSections.defense ? "expand" : ""}`}>
                  <div className="attribute-score-header">
                    <div className="custon-align">
                      <LabelText
                        className="comparison-table-header"
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.finalScoreZscore"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.finalScoreByPositionZscore"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.finalScoreByPositionZscore"
                              : "playerDefenceUniverse.finalScoreZscore"
                          )
                        }
                      >
                        Defense
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.finalScoreZscore"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.finalScoreByPositionZscore"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.finalScoreByPositionZscore"
                          : "playerDefenceUniverse.finalScoreZscore") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.finalScoreByPositionZscore"
                                : "playerDefenceUniverse.finalScoreZscore") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.finalScoreZscore"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.finalScoreByPositionZscore"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.finalScoreByPositionZscore"
                                : "playerDefenceUniverse.finalScoreZscore"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <SecondaryButton
                      iconType={expandedSections.defense ? "keyboardarrowleft" : "keyboardarrowright"}
                      onClick={() => toggleExpand("defense")}
                      className="column-expand-btn"
                    />
                  </div>

                  <div className="test">
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.tacklingZScores"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.tacklingByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.tacklingByPositionZScores"
                              : "playerDefenceUniverse.tacklingZScores"
                          )
                        }
                      >
                        Tackling
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.tacklingZScores"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.tacklingByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.tacklingByPositionZScores"
                          : "playerDefenceUniverse.tacklingZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.tacklingZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.tacklingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.tacklingByPositionZScores"
                                : "playerDefenceUniverse.tacklingZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.tacklingZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.tacklingByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.tacklingByPositionZScores"
                                : "playerDefenceUniverse.tacklingZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.defensiveHeadersZScores"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.defensiveHeadersByPosition"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.defensiveHeadersByPosition"
                              : "playerDefenceUniverse.defensiveHeadersZScores"
                          )
                        }
                      >
                        Def. headers
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.defensiveHeadersZScores"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.defensiveHeadersByPosition"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.defensiveHeadersByPosition"
                          : "playerDefenceUniverse.defensiveHeadersZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.defensiveHeadersZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.defensiveHeadersByPosition"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.defensiveHeadersByPosition"
                                : "playerDefenceUniverse.defensiveHeadersZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.defensiveHeadersZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.defensiveHeadersByPosition"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.defensiveHeadersByPosition"
                                : "playerDefenceUniverse.defensiveHeadersZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                    <div className="custon-align">
                      <LabelText
                        onClick={() =>
                          handleSortClick(
                            isPlayerLeague
                              ? "playerDefenceLeague.aggressionZScores"
                              : isPlayerPosition
                              ? "playerDefenceUniverse.aggressionByPositionZScores"
                              : isPlayerLeague && isPlayerPosition
                              ? "playerDefenceLeague.aggressionByPositionZScores"
                              : "playerDefenceUniverse.aggressionZScores"
                          )
                        }
                      >
                        Ball Recovery
                      </LabelText>
                      {sortKey ===
                        (isPlayerLeague
                          ? "playerDefenceLeague.aggressionZScores"
                          : isPlayerPosition
                          ? "playerDefenceUniverse.aggressionByPositionZScores"
                          : isPlayerLeague && isPlayerPosition
                          ? "playerDefenceLeague.aggressionByPositionZScores"
                          : "playerDefenceUniverse.aggressionZScores") && (
                        <img
                          src={
                            sortKey ===
                              (isPlayerLeague
                                ? "playerDefenceLeague.aggressionZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.aggressionByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.aggressionByPositionZScores"
                                : "playerDefenceUniverse.aggressionZScores") && isAscending
                              ? SortArrowAscIcon
                              : SortArrowDescIcon
                          }
                          onClick={() =>
                            handleSortClick(
                              isPlayerLeague
                                ? "playerDefenceLeague.aggressionZScores"
                                : isPlayerPosition
                                ? "playerDefenceUniverse.aggressionByPositionZScores"
                                : isPlayerLeague && isPlayerPosition
                                ? "playerDefenceLeague.aggressionByPositionZScores"
                                : "playerDefenceUniverse.aggressionZScores"
                            )
                          }
                          className="sort-img"
                        />
                      )}
                    </div>
                  </div>
                </TableCell>
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("starts")}>
                      Starts /As Sub
                    </LabelText>
                    {sortKey === "starts" && (
                      <img
                        src={sortKey === "starts" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("starts")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("minutesPlayed")}>
                      Mins Played
                    </LabelText>
                    {sortKey === "minutesPlayed" && (
                      <img
                        src={sortKey === "minutesPlayed" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("minutesPlayed")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                {/* Transfer Value column Commented as per WI-1019 */}
                {/* <TableCell>
                                    <div className='custon-align'>
                                        <LabelText className='comparison-table-header' onClick={() => handleSortClick('transferValue')}>Transfer Value</LabelText>
                                        {sortKey === 'transferValue' && (
                                            <img
                                                src={sortKey === 'transferValue' && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                                                onClick={() => handleSortClick('transferValue')}
                                                className="sort-img"
                                            />)}
                                    </div>
                                </TableCell> */}
                {/* Transfer Value column Commented as per WI-1019 */}

                {/* As per WI-1019, show Transfer market Value in Market Value column     */}
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("marketValue")}>
                      Market Value
                    </LabelText>
                    {sortKey === "marketValue" && (
                      <img
                        src={sortKey === "marketValue" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("marketValue")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                
                {/* As per WI-1019, show Transfer market Value in Market Value column     */}

                
                <TableCell>
                  <div className="custon-align">
                    <LabelText className="comparison-table-header" onClick={() => handleSortClick("contract.months")}>
                      Contract left
                    </LabelText>
                    {sortKey === "contract.months" && (
                      <img
                        src={sortKey === "contract.months" && isAscending ? SortArrowAscIcon : SortArrowDescIcon}
                        onClick={() => handleSortClick("contract.months")}
                        className="sort-img"
                      />
                    )}
                  </div>
                </TableCell>
                <TableCell className="right-table-menu-main"></TableCell>
                {/* <TableCell>Contract Value</TableCell> */}
              </TableRow>
            </TableHead>

            <TableBody>
              {filterSortData.map((player, index) => {
                const displayedData = getDisplayedData(player);
                return (
                  <React.Fragment key={index}>
                    {/* Main Row */}
                    <StyledTableRow key={index} className={`player-row ${player.playerId === benchmarkID ? "" : ""}`}>
                    {/* {!isFullView &&(<TableCell></TableCell>)} */}

                      <TableCell>
                        <div className="player-row">
                          {player?.isInjured && (
                            <CustomizedTooltips title="Currently injured" isByComparison={true}>
                              <div className="player-injured-chip">
                                <LabelText className="player-comparision-table-chip">INJ</LabelText>
                              </div>
                            </CustomizedTooltips>
                          )}
                          <PlayerAvatar
                            className={`player-table-image ${selectedPlayerIds.includes(player.playerId) ? "hidden" : ""}`}
                            style={{
                              backgroundImage: `url(${player?.playerImageURL || ""})`,
                            }}
                            backgroundImage={player?.playerImageURL ? player?.playerImageURL : noImagePlayer}
                          ></PlayerAvatar>
                          {/* <Checkbox
                                                    className={`player-circle-checkbox  ${selectedPlayerIds.includes(player.playerId) ? 'visible' : ''}`}
                                                    checked={selectedPlayerIds.includes(player.playerId)}
                                                    onChange={() => handleCheckboxChange(player.playerId)}
                                                    icon={<RadioButtonUncheckedIcon sx={{height:'32px',width:'32px',background: '#FFF'}}/>}
                                                    checkedIcon={<CheckCircleIcon sx={{height:'32px',width:'32px'}} />}
                                                /> */}
                          <input
                            type="checkbox"
                            checked={selectedPlayerIds.includes(player.playerId)}
                            onChange={() => handleCheckboxChange(player.playerId)}
                            className={`circle-checkbox  ${selectedPlayerIds.includes(player.playerId) ? "visible" : ""}`}
                          />
                          <div className="player-row-details">
                            <LabelText
                              className="player-filter-labeltext"
                              onClick={() => {
                                navigate(`/player/${player.playerId}`);
                              }}
                            >
                              {player.playerLabel}
                            </LabelText>
                            <LabelNumber className="attack-defense-data">{player.topPosition}</LabelNumber>
                            {/* <LabelNumber className="attack-defense-data">{player.topPosition}</LabelNumber> */}
                          </div>
                        </div>
                      </TableCell>
                      {/* <TableCell style={{textWrap:'nowrap'}}>
                        <LabelNumber className="table-age-text">{player.topPosition}</LabelNumber>
                      </TableCell> */}
                      {/* <TableCell>
                        <LabelNumber className="table-age-text">{player.age}</LabelNumber>
                      </TableCell> */}
                      <TableCell>
                        <LabelNumber className="table-age-text">{player.wagesText === "0" ? "--" : player.wagesText}</LabelNumber>
                      </TableCell>
                      <TableCell>
                        <LabelNumber className="table-age-text">
                          {player.trueValue ?   formatNumberToKAndM(player.trueValue) : '--'}
                        </LabelNumber>
                      </TableCell>
                      <TableCell className={`sub-header sub-header-body ${expandedSections.finalThird ? "expand" : ""}`}>
                        <div className="sub-main-wrapper">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.finalThird.finalScore),
                              color: getTextColor(Number(displayedData.finalThird.finalScore?.toFixed(2))),
                            }}
                          >
                            {displayedData.finalThird.finalScore >= 1 ? (
                              <>
                                <LabelNumber className="player-card-value">
                                  {displayedData.finalThird.finalScore >= 99 ? (
                                    <span className="gold-star-shortlist-table">
                                      <img src={GoldStar} alt="star-performer" />
                                    </span>
                                  ) : null}
                                  {displayedData.finalThird.finalScore === 100 ? "99.99" : displayedData.finalThird.finalScore?.toFixed(2)}
                                </LabelNumber>
                              </>
                            ) : (
                              <>
                                <CustomizedTooltips title="Not enough data">
                                  <img src={InfoIcon} height={16} width={16} />
                                </CustomizedTooltips>
                                <LabelNumber className="player-card-value">--</LabelNumber>
                              </>
                            )}
                          </div>
                          <div className="sub-score-container">
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.finalThird.finishingShots),
                                color: getTextColor(Number(displayedData.finalThird.finishingShots?.toFixed(2))),
                              }}
                            >
                              {displayedData.finalThird.finishingShots >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.finalThird.finishingShots >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.finalThird.finishingShots === 100 ? "99.99" : displayedData.finalThird.finishingShots?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.finalThird.finishingAerial),
                                color: getTextColor(Number(displayedData.finalThird.finishingAerial?.toFixed(2))),
                              }}
                            >
                              {displayedData.finalThird.finishingAerial >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.finalThird.finishingAerial >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.finalThird.finishingAerial === 100 ? "99.99" : displayedData.finalThird.finishingAerial?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.finalThird.attackPositioning),
                                color: getTextColor(Number(displayedData.finalThird.attackPositioning?.toFixed(2))),
                              }}
                            >
                              {displayedData.finalThird.attackPositioning >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.finalThird.attackPositioning >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.finalThird.attackPositioning === 100 ? "99.99" : displayedData.finalThird.attackPositioning?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell className={`sub-header sub-header-body ${expandedSections.buildUpPlay ? "expand expand-big" : ""}`}>
                        <div className="sub-main-wrapper">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.buildUpPlay.finalScore),
                              color: getTextColor(Number(displayedData.buildUpPlay.finalScore?.toFixed(2))),
                            }}
                          >
                            {displayedData.buildUpPlay.finalScore >= 1 ? (
                              <>
                                <LabelNumber className="player-card-value">
                                  {displayedData.buildUpPlay.finalScore >= 99 ? (
                                    <span className="gold-star-shortlist-table">
                                      <img src={GoldStar} alt="star-performer" />
                                    </span>
                                  ) : null}
                                  {displayedData.buildUpPlay.finalScore === 100 ? "99.99" : displayedData.buildUpPlay.finalScore?.toFixed(2)}
                                </LabelNumber>
                              </>
                            ) : (
                              <>
                                <CustomizedTooltips title="Not enough data">
                                  <img src={InfoIcon} height={16} width={16} />
                                </CustomizedTooltips>
                                <LabelNumber className="player-card-value">--</LabelNumber>
                              </>
                            )}
                          </div>
                          <div className="sub-score-container">
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.creativity),
                                color: getTextColor(Number(displayedData.buildUpPlay.creativity?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.creativity >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.creativity >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.creativity === 100 ? "99.99" : displayedData.buildUpPlay.creativity?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.passingAccuracy),
                                color: getTextColor(Number(displayedData.buildUpPlay.passingAccuracy?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.passingAccuracy >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.passingAccuracy >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.passingAccuracy === 100 ? "99.99" : displayedData.buildUpPlay.passingAccuracy?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.dribbling),
                                color: getTextColor(Number(displayedData.buildUpPlay.dribbling?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.dribbling >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.dribbling >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.dribbling === 100 ? "99.99" : displayedData.buildUpPlay.dribbling?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.crossing),
                                color: getTextColor(Number(displayedData.buildUpPlay.crossing?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.crossing >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.crossing >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.crossing === 100 ? "99.99" : displayedData.buildUpPlay.crossing?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell className={`sub-header sub-header-body ${expandedSections.defense ? "expand" : ""}`}>
                        <div className="sub-main-wrapper">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.defence.finalScore),
                              color: getTextColor(Number(displayedData.defence.finalScore?.toFixed(2))),
                            }}
                          >
                            {displayedData.defence.finalScore >= 1 ? (
                              <>
                                <LabelNumber className="player-card-value">
                                  {displayedData.defence.finalScore >= 99 ? (
                                    <span className="gold-star-shortlist-table">
                                      <img src={GoldStar} alt="star-performer" />
                                    </span>
                                  ) : null}
                                  {displayedData.defence.finalScore === 100 ? "99.99" : displayedData.defence.finalScore?.toFixed(2)}
                                </LabelNumber>
                              </>
                            ) : (
                              <>
                                <CustomizedTooltips title="Not enough data">
                                  <img src={InfoIcon} height={16} width={16} />
                                </CustomizedTooltips>
                                <LabelNumber className="player-card-value">--</LabelNumber>
                              </>
                            )}
                          </div>
                          <div className="sub-score-container">
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.defence.tackling),
                                color: getTextColor(Number(displayedData.defence.tackling?.toFixed(2))),
                              }}
                            >
                              {displayedData.defence.tackling >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.defence.tackling >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.defence.tackling === 100 ? "99.99" : displayedData.defence.tackling?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.defence.defensiveHeaders),
                                color: getTextColor(Number(displayedData.defence.defensiveHeaders?.toFixed(2))),
                              }}
                            >
                              {displayedData.defence.defensiveHeaders >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.defence.defensiveHeaders >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.defence.defensiveHeaders === 100 ? "99.99" : displayedData.defence.defensiveHeaders?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.defence.aggression),
                                color: getTextColor(Number(displayedData.defence.aggression?.toFixed(2))),
                              }}
                            >
                              {displayedData.defence.aggression >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.defence.aggression >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.defence.aggression === 100 ? "99.99" : displayedData.defence.aggression?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell style={{textWrap:'nowrap',display:'flex',alignItems:'center',gap:'10px',borderBottom:'none'}}>
                        {player?.archetype?.archetypeName ? (
                          <>
                              <LabelNumber className="table-age-text">{player?.archetype?.archetypeName!}</LabelNumber>
                              <img src={InfoIcon} height={24} width={24} onClick={() => hanldeInfoClick(player?.archetype?.id!,player?.archetype?.archetypeName!)}/>
                          </>
                        ) :(
                            <LabelNumber>--</LabelNumber>
                        )}
                      </TableCell>
                      <TableCell>
                        <CustomizedTooltips title={player.clubName}>
                          <img
                            src={player.clubImageURL ? player.clubImageURL : noImageClub}
                            alt="clubImage"
                            className="player-club-image"
                          />
                        </CustomizedTooltips>
                      </TableCell>
                      <TableCell>
                        <CustomizedTooltips title={player.nationality[0]?.name}>
                          <img
                            src={
                              player.nationality[0]?.alpha3code
                                ? `/assets/country_flags/${player.nationality[0]?.alpha3code}.svg`
                                : noImageFlag
                            }
                            alt="Country Flag"
                            className="player-country-image"
                          />
                        </CustomizedTooltips>
                      </TableCell>
                      
                      <TableCell>
                        <LabelNumber className="table-age-text">{player.heightInCM + "CM"}</LabelNumber>
                      </TableCell>
                      <TableCell>
                        <div
                          className="score-content"
                          style={{
                            backgroundColor: getBackgroundColor(player.attackContribution, true),
                            color: getTextColor(player.attackContribution),
                          }}
                        >
                          {player.attackContribution >= 1 ? (
                            <>
                              <LabelNumber className="player-card-value">
                                {player?.attackContribution >= 99 ? (
                                  <span className="gold-star-shortlist-table">
                                    <img src={GoldStar} alt="star-performer" />
                                  </span>
                                ) : null}
                                {player.attackContribution === 100 ? "99.99" : player.attackContribution}
                              </LabelNumber>
                            </>
                          ) : (
                            <>
                              <CustomizedTooltips title="Not enough data">
                                <img src={InfoIcon} height={16} width={16} />
                              </CustomizedTooltips>
                              <LabelNumber className="player-card-value">--</LabelNumber>
                            </>
                          )}
                        </div>
                      </TableCell>
                      <TableCell className={`sub-header sub-header-body ${expandedSections.finalThird ? "expand" : ""}`}>
                        <div className="sub-main-wrapper">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.finalThird.finalScore),
                              color: getTextColor(Number(displayedData.finalThird.finalScore?.toFixed(2))),
                            }}
                          >
                            {displayedData.finalThird.finalScore >= 1 ? (
                              <>
                                <LabelNumber className="player-card-value">
                                  {displayedData.finalThird.finalScore >= 99 ? (
                                    <span className="gold-star-shortlist-table">
                                      <img src={GoldStar} alt="star-performer" />
                                    </span>
                                  ) : null}
                                  {displayedData.finalThird.finalScore === 100 ? "99.99" : displayedData.finalThird.finalScore?.toFixed(2)}
                                </LabelNumber>
                              </>
                            ) : (
                              <>
                                <CustomizedTooltips title="Not enough data">
                                  <img src={InfoIcon} height={16} width={16} />
                                </CustomizedTooltips>
                                <LabelNumber className="player-card-value">--</LabelNumber>
                              </>
                            )}
                          </div>
                          <div className="sub-score-container">
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.finalThird.finishingShots),
                                color: getTextColor(Number(displayedData.finalThird.finishingShots?.toFixed(2))),
                              }}
                            >
                              {displayedData.finalThird.finishingShots >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.finalThird.finishingShots >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.finalThird.finishingShots === 100 ? "99.99" : displayedData.finalThird.finishingShots?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.finalThird.finishingAerial),
                                color: getTextColor(Number(displayedData.finalThird.finishingAerial?.toFixed(2))),
                              }}
                            >
                              {displayedData.finalThird.finishingAerial >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.finalThird.finishingAerial >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.finalThird.finishingAerial === 100 ? "99.99" : displayedData.finalThird.finishingAerial?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.finalThird.attackPositioning),
                                color: getTextColor(Number(displayedData.finalThird.attackPositioning?.toFixed(2))),
                              }}
                            >
                              {displayedData.finalThird.attackPositioning >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.finalThird.attackPositioning >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.finalThird.attackPositioning === 100 ? "99.99" : displayedData.finalThird.attackPositioning?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </TableCell>

                      <TableCell className={`sub-header sub-header-body ${expandedSections.buildUpPlay ? "expand expand-big" : ""}`}>
                        <div className="sub-main-wrapper">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.buildUpPlay.finalScore),
                              color: getTextColor(Number(displayedData.buildUpPlay.finalScore?.toFixed(2))),
                            }}
                          >
                            {displayedData.buildUpPlay.finalScore >= 1 ? (
                              <>
                                <LabelNumber className="player-card-value">
                                  {displayedData.buildUpPlay.finalScore >= 99 ? (
                                    <span className="gold-star-shortlist-table">
                                      <img src={GoldStar} alt="star-performer" />
                                    </span>
                                  ) : null}
                                  {displayedData.buildUpPlay.finalScore === 100 ? "99.99" : displayedData.buildUpPlay.finalScore?.toFixed(2)}
                                </LabelNumber>
                              </>
                            ) : (
                              <>
                                <CustomizedTooltips title="Not enough data">
                                  <img src={InfoIcon} height={16} width={16} />
                                </CustomizedTooltips>
                                <LabelNumber className="player-card-value">--</LabelNumber>
                              </>
                            )}
                          </div>
                          <div className="sub-score-container">
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.creativity),
                                color: getTextColor(Number(displayedData.buildUpPlay.creativity?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.creativity >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.creativity >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.creativity === 100 ? "99.99" : displayedData.buildUpPlay.creativity?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.passingAccuracy),
                                color: getTextColor(Number(displayedData.buildUpPlay.passingAccuracy?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.passingAccuracy >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.passingAccuracy >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.passingAccuracy === 100 ? "99.99" : displayedData.buildUpPlay.passingAccuracy?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.dribbling),
                                color: getTextColor(Number(displayedData.buildUpPlay.dribbling?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.dribbling >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.dribbling >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.dribbling === 100 ? "99.99" : displayedData.buildUpPlay.dribbling?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.buildUpPlay.crossing),
                                color: getTextColor(Number(displayedData.buildUpPlay.crossing?.toFixed(2))),
                              }}
                            >
                              {displayedData.buildUpPlay.crossing >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.buildUpPlay.crossing >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.buildUpPlay.crossing === 100 ? "99.99" : displayedData.buildUpPlay.crossing?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell className={`sub-header sub-header-body ${expandedSections.defense ? "expand" : ""}`}>
                        <div className="sub-main-wrapper">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.defence.finalScore),
                              color: getTextColor(Number(displayedData.defence.finalScore?.toFixed(2))),
                            }}
                          >
                            {displayedData.defence.finalScore >= 1 ? (
                              <>
                                <LabelNumber className="player-card-value">
                                  {displayedData.defence.finalScore >= 99 ? (
                                    <span className="gold-star-shortlist-table">
                                      <img src={GoldStar} alt="star-performer" />
                                    </span>
                                  ) : null}
                                  {displayedData.defence.finalScore === 100 ? "99.99" : displayedData.defence.finalScore?.toFixed(2)}
                                </LabelNumber>
                              </>
                            ) : (
                              <>
                                <CustomizedTooltips title="Not enough data">
                                  <img src={InfoIcon} height={16} width={16} />
                                </CustomizedTooltips>
                                <LabelNumber className="player-card-value">--</LabelNumber>
                              </>
                            )}
                          </div>
                          <div className="sub-score-container">
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.defence.tackling),
                                color: getTextColor(Number(displayedData.defence.tackling?.toFixed(2))),
                              }}
                            >
                              {displayedData.defence.tackling >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.defence.tackling >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.defence.tackling === 100 ? "99.99" : displayedData.defence.tackling?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.defence.defensiveHeaders),
                                color: getTextColor(Number(displayedData.defence.defensiveHeaders?.toFixed(2))),
                              }}
                            >
                              {displayedData.defence.defensiveHeaders >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.defence.defensiveHeaders >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.defence.defensiveHeaders === 100 ? "99.99" : displayedData.defence.defensiveHeaders?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                            <div
                              className="score-content"
                              style={{
                                backgroundColor: getBackgroundColor(displayedData.defence.aggression),
                                color: getTextColor(Number(displayedData.defence.aggression?.toFixed(2))),
                              }}
                            >
                              {displayedData.defence.aggression >= 1 ? (
                                <>
                                  <LabelNumber className="player-card-value">
                                    {displayedData.defence.aggression >= 99 ? (
                                      <span className="gold-star-shortlist-table">
                                        <img src={GoldStar} alt="star-performer" />
                                      </span>
                                    ) : null}
                                    {displayedData.defence.aggression === 100 ? "99.99" : displayedData.defence.aggression?.toFixed(2)}
                                  </LabelNumber>
                                </>
                              ) : (
                                <>
                                  <CustomizedTooltips title="Not enough data">
                                    <img src={InfoIcon} height={16} width={16} />
                                  </CustomizedTooltips>
                                  <LabelNumber className="player-card-value">--</LabelNumber>
                                </>
                              )}
                            </div>
                          </div>
                        </div>
                      </TableCell>
                      <TableCell>
                        <LabelNumber className="table-age-text">
                          {player.starts}/{player.appearancesAsSub}
                        </LabelNumber>
                      </TableCell>
                      <TableCell>
                        <LabelNumber className="table-age-text">{player.minutesPlayed === 0 ? "--" : player.minutesPlayed}</LabelNumber>
                      </TableCell>
                      {/* <TableCell><LabelNumber className='table-age-text'>{player.transferValueText}</LabelNumber></TableCell> */}

                      {/* As per WI-1019, show Transfer market Value in Market Value column     */}
                      <TableCell>
                        <LabelNumber className="table-age-text">
                          {player.marketValueText === "0" ? "--" : player.marketValueText}
                        </LabelNumber>
                      </TableCell>
                      
                      {/* As per WI-1019, show Transfer market Value in Market Value column     */}

                      {/* <TableCell>
                        <LabelNumber className="table-age-text">{player.wagesText === "0" ? "--" : player.wagesText}</LabelNumber>
                      </TableCell> */}
                      <TableCell>
                        <LabelNumber className="table-age-text">{player.contract.text}</LabelNumber>
                      </TableCell>
                      <TableCell className="right-table-menu-main">
                        <div className="right-table-menu">
                          <SecondaryButton iconType="menu" className="column-expand-btn" onClick={() => handleMenuOpen(player.playerId)} />
                          {menuOpenPlayerId === player.playerId && <>{renderMenuCard(player.playerId)}</>}
                        </div>
                      </TableCell>
                      {/* <TableCell>{player.contractValue}</TableCell> */}
                    </StyledTableRow>

                    {/* Expandable Row */}
                  </React.Fragment>
                );
              })}
            </TableBody>
            {benchmarkID !== null &&
              benchmarkRecord !== null &&
              (() => {
                const displayedData = getDisplayedData(benchmarkRecord);
                return (
                  <TableRow className="player-row benchmark-row" key={benchmarkID}>
                    <TableCell>
                      <div className="player-row">
                        <PlayerAvatar
                          className={`player-table-image ${selectedPlayerIds.includes(benchmarkRecord?.playerId!) ? "hidden" : ""}`}
                          style={{
                            backgroundImage: `url(${benchmarkRecord?.playerImageURL || ""})`,
                          }}
                          backgroundImage={benchmarkRecord?.playerImageURL ? benchmarkRecord.playerImageURL : noImagePlayer}
                        ></PlayerAvatar>
                        {/* <Checkbox
                                            className={`player-circle-checkbox  ${selectedPlayerIds.includes(benchmarkRecord?.playerId!) ? 'visible' : ''}`}
                                            checked={selectedPlayerIds.includes(benchmarkRecord?.playerId!)}
                                            onChange={() => handleCheckboxChange(benchmarkRecord?.playerId!)}
                                            icon={<RadioButtonUncheckedIcon />}
                                            checkedIcon={<CheckCircleIcon />}
                                        /> */}
                        <input
                          type="checkbox"
                          checked={selectedPlayerIds.includes(benchmarkRecord?.playerId)}
                          onChange={() => handleCheckboxChange(benchmarkRecord?.playerId)}
                          className={`circle-checkbox  ${selectedPlayerIds.includes(benchmarkRecord?.playerId) ? "visible" : ""}`}
                        />
                        <div className="player-row-details">
                          <LabelNumber className="attack-defense-data">Benchmark</LabelNumber>
                          <LabelText className="player-filter-labeltext">{benchmarkRecord?.playerLabel}</LabelText>
                          <LabelNumber className="attack-defense-data">{benchmarkRecord?.topPosition}</LabelNumber>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <CustomizedTooltips title={benchmarkRecord.clubName}>
                        <img
                          src={benchmarkRecord?.clubImageURL ? benchmarkRecord.clubImageURL : noImageClub}
                          alt="clubImage"
                          className="player-club-image"
                        />
                      </CustomizedTooltips>
                    </TableCell>
                    <TableCell>
                      <CustomizedTooltips title={benchmarkRecord.nationality[0]?.name}>
                        <img
                          src={
                            benchmarkRecord.nationality[0]?.alpha3code
                              ? `/assets/country_flags/${benchmarkRecord?.nationality[0]?.alpha3code}.svg`
                              : noImageFlag
                          }
                          alt="Country Flag"
                          className="player-country-image"
                        />
                      </CustomizedTooltips>
                    </TableCell>
                    <TableCell>
                      <LabelNumber className="table-age-text">{benchmarkRecord?.age}</LabelNumber>
                    </TableCell>
                    <TableCell>
                      <LabelNumber className="table-age-text">{benchmarkRecord?.heightInCM + "CM"}</LabelNumber>
                    </TableCell>
                    <TableCell>
                      <div
                        className="score-content"
                        style={{
                          backgroundColor: getBackgroundColor(benchmarkRecord?.attackContribution),
                          color: getTextColor(Number(benchmarkRecord?.attackContribution)),
                        }}
                      >
                        <LabelNumber className="player-card-value">
                          {benchmarkRecord?.attackContribution >= 99 ? (
                            <span className="gold-star-shortlist-table">
                              <img src={GoldStar} alt="star-performer" />
                            </span>
                          ) : null}
                          {benchmarkRecord?.attackContribution === 100 ? "99.99" : benchmarkRecord?.attackContribution}
                        </LabelNumber>
                      </div>
                    </TableCell>
                    <TableCell className={`sub-header sub-header-body ${expandedSections.finalThird ? "expand" : ""}`}>
                      <div className="sub-main-wrapper">
                        <div className="score-content" style={{ backgroundColor: getBackgroundColor(displayedData.finalThird.finalScore) }}>
                          <LabelNumber className="player-card-value">
                            {displayedData.finalThird.finalScore >= 99 ? (
                              <span className="gold-star-shortlist-table">
                                <img src={GoldStar} alt="star-performer" />
                              </span>
                            ) : null}
                            {displayedData.finalThird.finalScore === 100 ? "99.99" : displayedData.finalThird.finalScore}
                          </LabelNumber>
                        </div>
                        <div className="sub-score-container">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.finalThird.finishingShots),
                              color: getTextColor(Number(displayedData.finalThird.finishingShots?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.finalThird.finishingShots >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.finalThird.finishingShots === 100 ? "99.99" : displayedData.finalThird.finishingShots?.toFixed(2)}
                            </LabelNumber>
                          </div>
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.finalThird.finishingAerial),
                              color: getTextColor(Number(displayedData.finalThird.finishingAerial?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.finalThird.finishingAerial >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.finalThird.finishingAerial === 100 ? "99.99" : displayedData.finalThird.finishingAerial?.toFixed(2)}
                            </LabelNumber>
                          </div>
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.finalThird.attackPositioning),
                              color: getTextColor(Number(displayedData.finalThird.attackPositioning?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.finalThird.attackPositioning >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.finalThird.attackPositioning === 100 ? "99.99" : displayedData.finalThird.attackPositioning?.toFixed(2)}
                            </LabelNumber>
                          </div>
                        </div>
                      </div>
                    </TableCell>

                    <TableCell className={`sub-header sub-header-body ${expandedSections.buildUpPlay ? "expand expand-big" : ""}`}>
                      <div className="sub-main-wrapper">
                        <div
                          className="score-content"
                          style={{
                            backgroundColor: getBackgroundColor(displayedData.buildUpPlay.finalScore),
                            color: getTextColor(Number(displayedData.buildUpPlay.finalScore?.toFixed(2))),
                          }}
                        >
                          <LabelNumber className="player-card-value">
                            {displayedData.buildUpPlay.finalScore >= 99 ? (
                              <span className="gold-star-shortlist-table">
                                <img src={GoldStar} alt="star-performer" />
                              </span>
                            ) : null}
                            {displayedData.buildUpPlay.finalScore === 100 ? "99.99" : displayedData.buildUpPlay.finalScore?.toFixed(2)}
                          </LabelNumber>
                        </div>
                        <div className="sub-score-container">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.buildUpPlay.creativity),
                              color: getTextColor(Number(displayedData.buildUpPlay.creativity?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.buildUpPlay.creativity >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.buildUpPlay.creativity === 100 ? "99.99" : displayedData.buildUpPlay.creativity?.toFixed(2)}
                            </LabelNumber>
                          </div>
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.buildUpPlay.passingAccuracy),
                              color: getTextColor(Number(displayedData.buildUpPlay.passingAccuracy?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.buildUpPlay.passingAccuracy >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.buildUpPlay.passingAccuracy === 100 ? "99.99" : displayedData.buildUpPlay.passingAccuracy?.toFixed(2)}
                            </LabelNumber>
                          </div>
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.buildUpPlay.dribbling),
                              color: getTextColor(Number(displayedData.buildUpPlay.dribbling?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.buildUpPlay.dribbling >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.buildUpPlay.dribbling === 100 ? "99.99" : displayedData.buildUpPlay.dribbling?.toFixed(2)}
                            </LabelNumber>
                          </div>
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.buildUpPlay.crossing),
                              color: getTextColor(Number(displayedData.buildUpPlay.crossing?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.buildUpPlay.crossing >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.buildUpPlay.crossing === 100 ? "99.99" : displayedData.buildUpPlay.crossing?.toFixed(2)}
                            </LabelNumber>
                          </div>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell className={`sub-header sub-header-body ${expandedSections.defense ? "expand" : ""}`}>
                      <div className="sub-main-wrapper">
                        <div
                          className="score-content"
                          style={{
                            backgroundColor: getBackgroundColor(displayedData.defence.finalScore),
                            color: getTextColor(Number(displayedData.defence.finalScore?.toFixed(2))),
                          }}
                        >
                          <LabelNumber className="player-card-value">
                            {displayedData.defence.finalScore >= 99 ? (
                              <span className="gold-star-shortlist-table">
                                <img src={GoldStar} alt="star-performer" />
                              </span>
                            ) : null}
                            {displayedData.defence.finalScore === 100 ? "99.99" : displayedData.defence.finalScore?.toFixed(2)}
                          </LabelNumber>
                        </div>
                        <div className="sub-score-container">
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.defence.tackling),
                              color: getTextColor(Number(displayedData.defence.tackling?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.defence.tackling >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.defence.tackling === 100 ? "99.99" : displayedData.defence.tackling?.toFixed(2)}
                            </LabelNumber>
                          </div>
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.defence.defensiveHeaders),
                              color: getTextColor(Number(displayedData.defence.defensiveHeaders?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.defence.defensiveHeaders >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.defence.defensiveHeaders === 100 ? "99.99" : displayedData.defence.defensiveHeaders?.toFixed(2)}
                            </LabelNumber>
                          </div>
                          <div
                            className="score-content"
                            style={{
                              backgroundColor: getBackgroundColor(displayedData.defence.aggression),
                              color: getTextColor(Number(displayedData.defence.aggression?.toFixed(2))),
                            }}
                          >
                            <LabelNumber className="player-card-value">
                              {displayedData.defence.aggression >= 99 ? (
                                <span className="gold-star-shortlist-table">
                                  <img src={GoldStar} alt="star-performer" />
                                </span>
                              ) : null}
                              {displayedData.defence.aggression === 100 ? "99.99" : displayedData.defence.aggression?.toFixed(2)}
                            </LabelNumber>
                          </div>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell>
                      <LabelNumber className="table-age-text">
                        {benchmarkRecord?.starts}/{benchmarkRecord?.appearancesAsSub}
                      </LabelNumber>
                    </TableCell>
                    {/* <TableCell><LabelNumber className='table-age-text'>{benchmarkRecord?.transferValueText}</LabelNumber></TableCell> */}

                    {/* As per WI-1019, show Transfer market Value in Market Value column     */}
                    <TableCell>
                      <LabelNumber className="table-age-text">{benchmarkRecord?.marketValueText}</LabelNumber>
                    </TableCell>
                    {/* As per WI-1019, show Transfer market Value in Market Value column     */}

                    <TableCell>
                      <LabelNumber className="table-age-text">{benchmarkRecord?.wagesText}</LabelNumber>
                    </TableCell>
                    <TableCell>
                      <LabelNumber className="table-age-text">{benchmarkRecord?.contract.text}</LabelNumber>
                    </TableCell>
                    <TableCell className="right-table-menu-main">
                      <div className="right-table-menu">
                        <SecondaryButton
                          iconType="menu"
                          className="column-expand-btn"
                          onClick={() => handleMenuOpen(benchmarkRecord?.playerId!)}
                        />
                        {menuOpenPlayerId === benchmarkRecord?.playerId && <>{renderMenuCard(benchmarkRecord?.playerId)}</>}
                      </div>
                    </TableCell>
                  </TableRow>
                );
              })()}
          </Table>
        </TableContainer>
      </div>
      <ArchetypeInfoDrawer
                          sidebarOpen={sidebarOpen}
                          setSidebarOpen={setSidebarOpen}
                          //archetypeName={archetypeData[0]?.archetypeName!}
                          //activeArchetypeID={archetypeData[0]?.archetypeId!}
                          archetypeName={activeArchetypeName}
                          activeArchetypeID={archetypeID}
                        />

      {!isFromSimulation &&(
            <div className="table-bottom-container">
              <div className="left-content">
                <SecondaryButton iconType="score" onClick={() => setIsScoreByComparison(!scoreByComparison)} isSelected={scoreByComparison} />
                {noneSelected ? (
                  <SecondaryButton label="Select all" onClick={handleSelectAll} />
                ) : allSelected ? (
                  <SecondaryButton label="Deselect all" onClick={handleDeselectAll} />
                ) : (
                  <>
                    <SecondaryButton label="Select all" onClick={handleSelectAll} />
                    <SecondaryButton label="Deselect all" onClick={handleDeselectAll} />
                  </>
                )}
                {filterSortData.length > 0 && (<PrimaryButton label='Export to CSV' onClick={exportToCsv}/>)} 
              </div>
              {!noneSelected && (
                <div className="right-content">
                  <LabelNumber className="attack-defense-data">SELECTION OPTIONS:</LabelNumber>
                  {isFormSortList && <SecondaryButton label="Remove" isRemoveText={true} onClick={handleRemovePlayer} />}
                  {isFormSortList ? (
                    <>{/* <SecondaryButton label="Add to another shortlist" onClick={handleAddorUpdateSortList} /> */}</>
                  ) : (
                    <SecondaryButton label="Add to shortlist" onClick={handleAddorUpdateSortList} />
                  )}
                </div>
              )}
          </div>
      )}
      
      {displayCustomNotification && (
        <PWNotification
          message={customNotificationContent}
          setIsNotification={() => setDisplayCustomNotification(false)}
          isDisplayCloseIcon={true}
          className="player-filter-notification add-similar-notification"
        />
      )}

      {scoreByComparison && (
        <div className="comparison-by-score-container">
          <div className="comparison-by-score-content">
            <LabelText className="comparison-score-text">Attributes scored in relation to...</LabelText>
            <Switch
              id="position"
              toggled={isPlayerPosition}
              onChange={handlePositionToggle}
              source="Filter"
              title="Player’s position"
              isByComparison={true}
            />
            <Switch
              id="league"
              toggled={isPlayerLeague}
              onChange={handleLeagueToggle}
              source="Filter"
              title="Player’s league"
              isByComparison={true}
            />
          </div>
          <div className="score-notification-closeIcon">
            <CloseIcon sx={{ color: "white" }} onClick={() => setIsScoreByComparison(!scoreByComparison)} />
          </div>
        </div>
      )}
      {isFullViewTable && (
        <DrawerComponent
          open={isFullViewTable}
          onClose={() => {
            setIsFullViewTable(false);
          }}
          styleVariant="value-graph"
          customClassName="career-drawer-main career-drawer"
        >
          <FullViewSimulationPlayersTable
            sortKey={sortKey}
            setSortKey={setSortKey}
            tableData={tableData!}
            isFormSortList={false}
            benchmarkID={0}
            isFromSimulation={true}
            onClose={() => {
              setIsFullViewTable(false);
            }}
            isFullView={isFullViewTable}
          />
        </DrawerComponent>
      )}
    </>
  );
};

export default SimulationPlayersTable;
